import { cn } from "@/utils/class-name";

const SUPPORT_EMAIL = "support@verdi.ag";

interface SupportEmailLinkProps {
    /** Defaults to the address. Inside `Trans`, the translation's tag supplies it. */
    children?: React.ReactNode;
    className?: string;
}

/** A `mailto:` link to Verdi Support, inheriting the surrounding text colour. */
export function SupportEmailLink({ children = SUPPORT_EMAIL, className }: SupportEmailLinkProps) {
    return (
        <a className={cn("underline underline-offset-4", className)} href={`mailto:${SUPPORT_EMAIL}`}>
            {children}
        </a>
    );
}
